module.exports = __webpack_public_path__ + "img/Camden_ABT_Green.4aa860ee.png";